// extracted by mini-css-extract-plugin
export var carrierIcon = "_vw-0";
export var carrierLogo = "_vw-1";
export var detailsSection = "_vw-2";